import React, { useState } from 'react'
import ReporteColaborador from './ReporteColaborador';
import ReportePersonalSucursal from './ReportePersonalSucursal';

function PrincipalPersoxSuc() {
    const [ventana, setVentana] = useState(0);
    return (
        <>
            <div className='container-fluid bg-dark py-1 bg-gradient'>
                <div className='btn-group btn-group-sm'>
                    <button className={`btn btn-sm ${ventana===0?'bg-gradient btn-dark':'btn-light'}`} onClick={()=>setVentana(0)}>Personal Activos</button>
                    <button className={`btn btn-sm ${ventana===1?'bg-gradient btn-dark':'btn-light'}`} onClick={()=>setVentana(1)}>Personal Activo detalle</button>
                </div>
            </div>
            {ventana==0&&<ReporteColaborador/>}
            {ventana==1&&<ReportePersonalSucursal/>}
        </>
    )
}

export default PrincipalPersoxSuc